"use strict";
/**
 * @module Services.Authentication
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var CredentialsSerialiser = require("./../../services/authentication/credentials-serialiser");
/**
 * Serialiser for {@link SecurityCommandScript}
 */
var ChangePrincipalRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(ChangePrincipalRequestSerialiserClass, _super);
    function ChangePrincipalRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SecurityCommandScript} to the stream
     *
     * @param bis   the input stream
     * @param value the {@link SecurityCommandScript} to be written
     */
    ChangePrincipalRequestSerialiserClass.prototype.write = function (output, req) {
        Codec.writeString(output, req.principal);
        CredentialsSerialiser.write(output, req.credentials);
    };
    return ChangePrincipalRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ChangePrincipalRequestSerialiserClass = ChangePrincipalRequestSerialiserClass;
/**
 * The {@link ChangePrincipalRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ChangePrincipalRequestSerialiser = new ChangePrincipalRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/change-principal/change-principal-request-serialiser.js
// module id = 1313
// module chunks = 0